var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndicador(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 21",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.89999 1.90546H18V3.57689H9.89999V1.90546ZM9.89999 5.24831H18V6.91974H9.89999V5.24831ZM9.89999 8.59117H18V10.2626H10.6993L9.89999 9.51046V8.59117ZM18 11.934V13.6055H12.0316C12.0316 13.0288 11.925 12.4605 11.7225 11.934H18Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1_9",
    fill: "inherit"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4445 0C3.72628 0 2.33339 1.39289 2.33339 3.11111V11.087C0.922869 12.0708 0 13.7054 0 15.5556C0 18.5625 2.43756 21 5.44444 21C8.45133 21 10.8889 18.5625 10.8889 15.5556C10.8889 13.7055 9.96607 12.0709 8.55561 11.0871V3.11111C8.55561 1.39289 7.16272 0 5.4445 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.33339 11.087L2.90547 11.9072L3.33339 11.6087V11.087H2.33339ZM8.55561 11.0871H7.55561V11.6088L7.9835 11.9072L8.55561 11.0871ZM3.33339 3.11111C3.33339 1.94518 4.27856 1 5.4445 1V-1C3.17399 -1 1.33339 0.840605 1.33339 3.11111H3.33339ZM3.33339 11.087V3.11111H1.33339V11.087H3.33339ZM1 15.5556C1 14.0461 1.75159 12.712 2.90547 11.9072L1.7613 10.2668C0.0941495 11.4296 -1 13.3648 -1 15.5556H1ZM5.44444 20C2.98985 20 1 18.0102 1 15.5556H-1C-1 19.1148 1.88528 22 5.44444 22V20ZM9.88889 15.5556C9.88889 18.0102 7.89904 20 5.44444 20V22C9.00361 22 11.8889 19.1148 11.8889 15.5556H9.88889ZM7.9835 11.9072C9.13734 12.7121 9.88889 14.0462 9.88889 15.5556H11.8889C11.8889 13.3648 10.7948 11.4297 9.12772 10.2669L7.9835 11.9072ZM7.55561 3.11111V11.0871H9.55561V3.11111H7.55561ZM5.4445 1C6.61043 1 7.55561 1.94518 7.55561 3.11111H9.55561C9.55561 0.840608 7.715 -1 5.4445 -1V1Z",
    fill: "inherit",
    mask: "url(#path-2-inside-1_1_9)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.44442,
    cy: 15.5554,
    r: 3.11111,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.58154,
    y: 7.30554,
    width: 1.8,
    height: 6.3,
    rx: 0.9,
    fill: "inherit"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicador);
export default __webpack_public_path__ + "static/media/indicador.b14893b40065635b6e90071130b82e94.svg";
export { ForwardRef as ReactComponent };